import { fetcher } from '@commenda/utils';

export async function consumeEntitlement(body: {
  entitlementId: string;
  corporationId: number;
  fiscalYear?: number;
}) {
  const response = await fetcher('entitlements-new/consume', {
    method: 'POST',
    body,
  });

  return response;
}
